module.exports = __webpack_public_path__ + "img/eco-logo.0b3d992f.png";